import { motion } from "framer-motion";
import Stack from "../../components/Utils/Stack.styled";
import Title from "../../components/Utils/Title.styled";
import PlaylistCard from "../../components/PlaylistCard/PlaylistCard";
import usePlayListStore from "../../stores/playlistStore";
import { Outlet, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
const PlaylistScreen = () => {
  const allPlaylists = usePlayListStore((state) => state.allPlaylists);
  const [currentAllPlaylist, setCurrentAllPlaylist] = useState(allPlaylists);
  const navigate = useNavigate();

  useEffect(() => {
    setCurrentAllPlaylist(allPlaylists);
  }, [allPlaylists]);

  const renderPlaylistCard = (name, i) => {
    return (
      <PlaylistCard
        key={i}
        playlistName={name}
        index={i}
        onClick={() => getSelectedPlaylist({ name: name })}
      />
    );
  };

  const getSelectedPlaylist = (value) => {
    navigate(`/results/playlist/${value.name}`);
  };

  return (
    <motion.div style={{ width: "100%" }}>
      <Stack
        direction="column"
        alignItems="start"
        justifyContent="start"
        paddingTop="70px"
        paddingBottom="70px"
        paddingLeft="40px"
        paddingRight="40px"
        gap="32"
      >
        <Title size="30px">Your Current Playlists</Title>
        <Stack direction="row" gap="32" style={{ flexWrap: "wrap" }}>
          {Array.from(currentAllPlaylist.keys()).map((name, i) =>
            renderPlaylistCard(name, i)
          )}
        </Stack>
      </Stack>
      <Outlet />
    </motion.div>
  );
};

export default PlaylistScreen;
